import { useEffect } from "react";
import useGlobalStore from "../../../store/global.store";
import { useRemote } from "../../../hooks/useRemote";

const BeaconSubCheck = () => {
  const hasBeaconAddOn = useGlobalStore((state) => state.hasBeaconAddOn);
  const { updateView } = useRemote();

  useEffect(() => {
    if (!hasBeaconAddOn) {
      updateView("Home");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasBeaconAddOn]);

  return null;
};

export default BeaconSubCheck;
